import * as React from 'react'
import axios from 'axios'
export const usePatchWebhookService = () => {
  const [data, setData] = React.useState<PatchWebhookServiceResponse>()
  const [loading, setLoading] = React.useState(false)

  const patchWebhookService = async ({ body }: PatchWebhookServiceProps) => {
    try {
      setLoading(true)

      await axios.patch('/api/webhooks/receive_token', body)

      setData({ success: true })
    } catch (error: any) {
      console.error('Patch request to webhook service failed:', error)

      setLoading(false)
      setData({
        success: false,
        message: error.response?.data?.errors[0] || 'Unknown error'
      })
    }
  }

  return {
    patchWebhookService,
    data,
    loading
  }
}

interface PatchWebhookServiceResponse {
  success: boolean
  message?: string
}

interface PatchWebhookServiceProps {
  body: Record<string, any>
}
